import React, { useState } from "react";
import parse from "html-react-parser";
import { Modal } from "react-bootstrap";
import HeroBanner from "components/sections/HeroBanner";
import { TECHNOLOGIES_DATA } from "config/data";
import { PORTFOLIO_DATA } from "config/portfolio_data";

const PortfolioPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("mobile");
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [promoDetail, setPromoDetail] = useState(null);

  const handleFilterChange = (category) => {
    setSelectedCategory(category.toLowerCase());
  };

  const handleDetailDialog = (openModal, data = null) => {
    setDetailModalOpen(openModal);
    setPromoDetail(data);
  };

  // Ensure category is an array before using .some()
  const filteredPromotions = PORTFOLIO_DATA.filter(
    (fi) => Array.isArray(fi.category) && fi.category.some((cat) => cat.toLowerCase() === selectedCategory.toLowerCase())
  );

  return (
    <>
      <HeroBanner
        title="Portfolio"
        subTitle="Our Work Speaks for Itself"
        desc="Take a look at some of our finest projects that showcase our expertise and innovation."
      />

      <section className="portfolio-section pt-0">
        <div className="container">
          {/* Filter Navigation */}
          <div className="flex gap-2 mb-3 overflow-x-auto hide-scrollbar filters">
            {Object.keys(TECHNOLOGIES_DATA).map((category) => {
              let value = category.toLowerCase();
              return (
                <button
                  key={value}
                  className={`btn btn-default filter-button ${selectedCategory === value ? "active" : ""}`}
                  onClick={() => handleFilterChange(value)}
                >
                  {category.toUpperCase()}
                </button>
              );
            })}
          </div>

          {/* Promotions Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
            {filteredPromotions.length > 0 ? (
              filteredPromotions.map((item) => (
                <div key={item.id} className="card portfolio-item" onClick={() => handleDetailDialog(true, item)}>
                  <div className="card-head">
                    <span className="card-img">
                      <img src={item.image} className="img-responsive" alt={item.title} />
                    </span>
                  </div>
                  <div className="card-body">
                    <div className="flex flex-wrap gap-1 mb-2">
                      {item.tags.map((tag, index) => (
                        <span key={index} className="fw-normal badge bg-slate-100 text-slate-500">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <small>{item.description}</small>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center w-full col-span-full border border-slate-50 rounded p-5">No projects found for this category.</p>
            )}
          </div>
        </div>
      </section>

      {/* Detail Modal */}
      <Modal show={detailModalOpen} onHide={() => setDetailModalOpen(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{promoDetail?.title || "Project Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex md:flex-row flex-col">
            <div className="sm:p-4 md:max-w-[400px] w-full">
              <span className="sm:rounded-md overflow-hidden inline-block">
                <img src={promoDetail?.image ?? "http://fakeimg.pl/365x365/"} alt={promoDetail?.title} />
              </span>
            </div>
            <div className="promo-content w-full p-4 md:max-h-[calc(100vh-100px)] overflow-y-auto md:py-5">
              {parse(promoDetail?.description ?? "<p>No description available.</p>")}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PortfolioPage;
